var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"inboxRef",staticClass:"inbox",class:_vm.inboxClass,attrs:{"id":_vm.elementId}},[_c('i',[_vm._v(_vm._s(_vm.loadingText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }